// extracted by mini-css-extract-plugin
export default {"root":"IconFolder_root__isYCz"};